exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#createPasswordPage .userEmail{margin:15px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader!./pages/xo-create-password/styles.less
// module id = ../node_modules/css-loader/index.js!../node_modules/less-loader/index.js!./pages/xo-create-password/styles.less
// module chunks = 1